import { GetBalanceUseCase } from '../domain/usecases/balance/GetBalanceUseCase';
import { GetCommissionsUseCase } from '../domain/usecases/balance/GetCommissionsUseCase';
import { GetDepositAccounts } from '../domain/usecases/balance/GetDepositAccountsUseCase';
import { GetHistoricUseCase } from '../domain/usecases/sell/GetHistoricUseCase';
import { GetSellResumePerDayUseCase } from '../domain/usecases/sell/GetSellResumePerDayUseCase';
import { ChangePasswordUseCase } from '../domain/usecases/session/ChangePasswordUseCase';
import { ChangeSessionTimeUseCase } from '../domain/usecases/session/ChangeSessionTimeUseCase';
import { GetBannerUseCase } from '../domain/usecases/ui/GetBannerUseCase';
import { balanceRepo, sellRepo, sessionRepo, uiRepo, skuRepo, historicRepo } from './repo_module';
import { GetIpUseCase } from '../domain/usecases/session/GetIpUseCase';
import { GetSkuDetailUseCase } from '../domain/usecases/sku/GetSkuDetailUseCase';
import { GetSkuDetailAfterActivationUseCase } from '../domain/usecases/sku/GetSkuDetailAfterActivationUseCase';
import { SellUseCase } from '../domain/usecases/sell/SellUseCase';
import { GetSkuDashboardUseCase } from '../domain/usecases/sku/GetSkuDashboardUseCase';
import { PosHasUsersUseCase } from '../domain/usecases/session/PosHasUsersUseCase';
import { LoginUseCase } from '../domain/usecases/session/LoginUseCase';
import { GetHistoricMovementsByDateUseCase } from '../domain/usecases/historic/GetHistoricMovementsByDateUseCase';
import { GetHistoricOpsByDateUseCase } from '../domain/usecases/historic/GetHistoricOpsByDateUseCase';
import { GetDashboardUseCase } from '../domain/usecases/sku/GetDashboardUseCase';
import { GetHistoricMovementsFilteredUseCase } from '../domain/usecases/historic/GetHistoricMovementsFiltered';
import { GetHistoricOpsFilteredUseCase } from '../domain/usecases/historic/GetHistoricOpsFiltered';

//BALANCE
export function getBalanceUseCase() {
    return new GetBalanceUseCase(balanceRepo());
}
export function getCommissionsUseCase() {
    return new GetCommissionsUseCase(balanceRepo());
}

// SELL
export function getSellResumePerDayUseCase() {
    return new GetSellResumePerDayUseCase(
        sellRepo(),
        historicRepo(),
    );
}

export function getHistoricUseCase() {
    return new GetHistoricUseCase(
        sellRepo()
    );
}
export function sellUseCase() {
    return new SellUseCase(sellRepo());
}

//UI
export function getBannerUseCase() {
    return new GetBannerUseCase(uiRepo())
}
export function getDepositAccountsUseCase() {
    return new GetDepositAccounts(balanceRepo());
}

//SESSION
export function posHasUsersUseCase() {
    return new PosHasUsersUseCase(sessionRepo());
}

export function loginUseCase() {
    return new LoginUseCase(sessionRepo());
}

export function changePasswordUseCase() {
    return new ChangePasswordUseCase(sessionRepo());
}

export function changeSessionTimeUseCase() {
    return new ChangeSessionTimeUseCase(sessionRepo());
}

export function getIpUseCase() {
    return new GetIpUseCase(sessionRepo());
}

//SKU
export function getSkuDetailUseCase() {
    return new GetSkuDetailUseCase(skuRepo());
}

export function getSkuDetailAfterActivationUseCase() {
    return new GetSkuDetailAfterActivationUseCase(skuRepo());
}

export function getDashboardUseCase() {
    return new GetDashboardUseCase(skuRepo());
}

export function getSkuDashboardUseCase() {
    return new GetSkuDashboardUseCase(skuRepo());
}

//HISTORIC
export function getHistoricMovementsByDateUseCase() {
    return new GetHistoricMovementsByDateUseCase(historicRepo());
}

export function getHistoricMovementsFilteredUseCase() {
    return new GetHistoricMovementsFilteredUseCase(historicRepo());
}

export function getHistoricOpsByDateUseCase() {
    return new GetHistoricOpsByDateUseCase(historicRepo());
}

export function getHistoricOpsFilteredUseCase() {
    return new GetHistoricOpsFilteredUseCase(historicRepo());
}